module.exports = __webpack_public_path__ + "static/media/confirm_dispatch.7385393f.svg";